import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "i-1098417318__a",
      width: "20",
      height: "20",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-rule": "evenodd",
        d: "M0 2.903C0 1.3 1.3 0 2.903 0h14.194a2.903 2.903 0 0 1 0 5.806H2.903A2.903 2.903 0 0 1 0 2.903M0 10c0-1.603 1.3-2.903 2.903-2.903h7.871a2.903 2.903 0 0 1 0 5.806h-7.87A2.903 2.903 0 0 1 0 10m2.903 4.194a2.903 2.903 0 1 0 0 5.806h14.194a2.903 2.903 0 1 0 0-5.806z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#i-1098417318__a)" }, [
      _createElementVNode("rect", {
        width: "20",
        height: "21.097",
        y: "-.452",
        fill: "currentColor",
        rx: ".645"
      })
    ], -1)
  ])))
}
export default { render: render }